//import { Typography } from '@mui/material';
import { Palette } from 'config';
import styled from 'styled-components';

export const SectionName = styled.h2`
  color: ${Palette.PrimaryGray._900};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 32px 40px;
  margin-bottom: 16px;
  border-radius: 8px;
  box-shadow: 0px 1px 3px 0px rgba(30, 50, 70, 0.1), 0px 1px 2px 0px rgba(30, 50, 70, 0.06);
`;
export const Form = styled.form`
  all: unset;
`;
/////

// export const AdditionlTextContainer1 = styled.div`
//   /* 12-16/Regular */
//   margin: 16px 0;
//   margin: 2em 0;
// `;

// export const AdditionlText1 = styled(Typography)`
//   color: ${() => Palette.PrimaryGray._700};
//   /* 12-16/Regular */
//   margin: 16px 0;
//   margin: 2em 0;
//   font-family: Roboto;
//   font-size: 12px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: 16px; /* 133.333% */
// `;
// export const Required1 = styled.span`
//   display: inline-block;
//   color: ${() => Palette.Primary._700};
//   font-family: Roboto;
//   font-size: 14px;
// `;
